import { Routes } from '@angular/router';
export const USAGE_ROUTES: Routes = [
  { path: 'usage', loadComponent: () => import('./pages/usage-logs/usage-logs.component').then((m) => m.UsageLogsComponent) },
];
